import { Col, Form, Row } from "antd";
import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import { Radio as AntRadio, Select } from "antd";

import { theme } from "../../../config";
import { validation } from "../../../constants";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { SelectWithLabel } from "../../molecules/SelectWithLabel";
import {
  FormItem,
  CharRefInputWrapper,
  InputTitle,
  FormItemWrapper,
  FormItemWrapperLeft,
  CharRefFormItemWrapper,
  RelationshipFormItemWrapper,
  CharRefFormItemWrapperLeft,
  NameContactNumberDiv,
  CharacterRefContainer,
  StyledTextInput,
  RadioContainer,
  ContactTimeFormItem,
  ContactTimeToFormItem,
  CharRefRadioText,
  EmailCharRefFormItemWrapper,
} from "./elements";
import { TextInput } from "../../atoms/TextInput";
import { Radio } from "../../atoms/Radio";
import { Props } from "./types";
import { useMediaQuery } from "../../../hooks/common";

const { Option } = Select;

const ApplicantContactsForm: FC<Props> = (props) => {
  const {
    onFinish,
    formRef,
    contactTimeOptionItems,
    isFreshGrad,
    onFreshGradStatusSelect,
  } = props;

  useLayoutEffect(() => {
    const values = formRef.getFieldsValue();
    if (values) {
      updateContactTimeFromOptItems();
      updateContactTimeToOptItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [contactTimeToOptItems, setContactTimeToOptItems] = useState(
    contactTimeOptionItems
  );
  const [contactTimeFromOptItems, setContactTimeFromOptItems] = useState(
    contactTimeOptionItems
  );

  const currentDate = new Date().toLocaleDateString("en-US");

  const updateContactTimeFromOptItems = () => {
    const _contactTimeFrom = formRef.getFieldValue("contact_time_from");
    let newItems = [...contactTimeFromOptItems];
    const today = new Date(`${currentDate} ${_contactTimeFrom}`);

    contactTimeToOptItems.forEach((item, index: number) => {
      const tempDate = new Date(`${currentDate} ${item.value}`);
      if (tempDate <= today) {
        newItems[index] = { value: item.value, disabled: true };
        setContactTimeToOptItems([...newItems]);
      } else {
        newItems[index] = { value: item.value, disabled: false };
        setContactTimeToOptItems([...newItems]);
      }
    });
  };

  const updateContactTimeToOptItems = () => {
    const _contactTimeTo = formRef.getFieldValue("contact_time_to");
    let newItems = [...contactTimeToOptItems];
    const today = new Date(`${currentDate} ${_contactTimeTo}`);

    contactTimeFromOptItems.forEach((item, index: number) => {
      const tempDate = new Date(`${currentDate} ${item.value}`);
      if (tempDate >= today) {
        newItems[index] = { value: item.value, disabled: true };
        setContactTimeFromOptItems([...newItems]);
      } else {
        newItems[index] = { value: item.value, disabled: false };
        setContactTimeFromOptItems([...newItems]);
      }
    });
  };

  const [formValues, setFormValues] = useState<any>({});
  const updateFieldValues = (e: any, field: string) => {
    const directValues = ["contact_time_from", "contact_time_to"];

    setFormValues({
      ...formValues,
      [field]: directValues.includes(field) ? e : e.target.value,
    });
    formRef.setFieldsValue({
      ...formRef.getFieldsValue(),
      [field]: directValues.includes(field) ? e : e.target.value,
    });

    switch (field) {
      case "contact_time_from":
        updateContactTimeFromOptItems();
        break;
      case "contact_time_to":
        updateContactTimeToOptItems();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setFormValues(formRef.getFieldsValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const charRef = () => {
    const forms: Array<JSX.Element> = [];

    forms.push(
      <CharRefInputWrapper>
        <NameContactNumberDiv>
          <CharRefFormItemWrapperLeft>
            <FormItem
              name={`name`}
              label="Name"
              validateTrigger={["onChange", "onBlur"]}
              rules={[textRules]}
            >
              <StyledTextInput placeholder="Name" />
            </FormItem>
          </CharRefFormItemWrapperLeft>
          <CharRefFormItemWrapper>
            <FormItem
              name={`contactNumber`}
              label="Contact number"
              validateTrigger={["onChange", "onBlur"]}
              rules={[textRules]}
            >
              <StyledTextInput placeholder="Contact Number" />
            </FormItem>
          </CharRefFormItemWrapper>
        </NameContactNumberDiv>
        <EmailCharRefFormItemWrapper>
          <FormItem
            name={`emailCharRef`}
            label="Email Address"
            validateTrigger={["onChange", "onBlur"]}
            rules={[emailCharRefRules]}
          >
            <TextInput placeholder="Email Address" />
          </FormItem>
        </EmailCharRefFormItemWrapper>
        <RelationshipFormItemWrapper>
          <FormItem
            name={`relationship`}
            label="Relationship to the person"
            validateTrigger={["onChange", "onBlur"]}
            rules={[textRules]}
          >
            <TextInput placeholder="Relationship To The Person" />
          </FormItem>
        </RelationshipFormItemWrapper>
      </CharRefInputWrapper>
    );

    return forms;
  };

  const textRules: object = validation.stringRules;
  const emailCharRefRules: object = validation.stringEmailRules;
  
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.mobileAndTablet);

  return (
    <>
      <Form
        onFinish={onFinish}
        form={formRef}
        validateMessages={validation.validateMessages}
      >
        <Row gutter={theme.gutter}>
          <Col span={24}>
            <FormItem
              name="linkedin_url"
              label="LinkedIn Url"
              rules={[{ type: "url" }]}
            >
              <span id={"linkedin_url"}>
                <InputWithLabel
                  label="LinkedIn URL (optional)"
                  type="default"
                  value={formValues?.linkedin_url}
                  onChange={(e) => {
                    updateFieldValues(e, "linkedin_url");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={theme.gutter}>
          <FormItemWrapperLeft>
            <FormItem
              name="email"
              label="Email address"
              rules={[
                {
                  ...textRules,
                  type: "email",
                },
              ]}
            >
              <span id={"email"}>
                <InputWithLabel
                  label="Email Address"
                  type="default"
                  value={formValues?.email}
                  onChange={(e) => {
                    updateFieldValues(e, "email");
                  }}
                />
              </span>
            </FormItem>
          </FormItemWrapperLeft>
          <FormItemWrapper>
            <FormItem
              name="contact_number"
              label="Contact number"
              rules={[textRules]}
            >
              <span id={"contact_number"}>
                <InputWithLabel
                  label="Contact Number"
                  type="default"
                  value={formValues?.contact_number}
                  onChange={(e) => {
                    updateFieldValues(e, "contact_number");
                  }}
                />
              </span>
            </FormItem>
          </FormItemWrapper>
        </Row>
        <Row gutter={theme.gutter}>
          <FormItemWrapperLeft>
            <ContactTimeFormItem
              name="contact_time_from"
              label="Best time to contact"
              rules={[textRules]}
            >
              <span id={"contact_time_from"}>
                <SelectWithLabel
                  label="Best Time To Contact"
                  placeholder={"From"}
                  selectOnChange={(e) => {
                    updateFieldValues(e, "contact_time_from");
                  }}
                  selectDefaultValue={formValues?.contact_time_from}
                  value={formValues?.contact_time_from}
                  optionItems={
                    <>
                      {contactTimeFromOptItems.map(
                        (item: any, index: number) => (
                          <Option
                            key={index}
                            value={item.value}
                            disabled={item.disabled}
                          >
                            {item.value}
                          </Option>
                        )
                      )}
                    </>
                  }
                  selectWidth={"202px"}
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                />
              </span>
            </ContactTimeFormItem>
          </FormItemWrapperLeft>
          <FormItemWrapper>
            <ContactTimeToFormItem
              name="contact_time_to"
              label="Best time to contact"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <span id={"contact_time_to"}>
                <SelectWithLabel
                  label={!isMobileOrTablet ? "‎‎" : ""}
                  placeholder={"To"}
                  selectOnChange={(e) => {
                    updateFieldValues(e, "contact_time_to");
                  }}
                  selectDefaultValue={formValues.contact_time_to}
                  value={formValues?.contact_time_to}
                  optionItems={
                    <>
                      {contactTimeToOptItems.map((item: any, index: number) => (
                        <Option
                          key={index}
                          value={item.value}
                          disabled={item.disabled}
                        >
                          {item.value}
                        </Option>
                      ))}
                    </>
                  }
                  selectWidth={"202px"}
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                />
              </span>
            </ContactTimeToFormItem>
          </FormItemWrapper>
        </Row>
        <Row gutter={theme.gutter}>
          <Col span={24}>
            <FormItem
              name="address"
              label="Present address"
              rules={[textRules]}
            >
              <span id={"address"}>
                <InputWithLabel
                  label="Present Address"
                  type="default"
                  value={formValues?.address}
                  onChange={(e) => {
                    updateFieldValues(e, "address");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={theme.gutter}>
          <Col span={24}>
            <InputTitle>
              Character Reference
              <RadioContainer>
                <AntRadio.Group
                  onChange={onFreshGradStatusSelect}
                  value={isFreshGrad}
                >
                  <Radio radioValue={false}>
                    <CharRefRadioText>I have work experience</CharRefRadioText>
                  </Radio>
                  {isMobileOrTablet && <br />}
                  <Radio radioValue={true}>
                    <CharRefRadioText>I’m a fresh graduate</CharRefRadioText>
                  </Radio>
                </AntRadio.Group>
              </RadioContainer>
              {!isFreshGrad && (
                <>
                  <br />• at least 3 references required preferably
                  <br />• preferably immediate head/superior from previous work
                </>
              )}
            </InputTitle>
            {!isFreshGrad && (
              <CharacterRefContainer>
                <Form.List
                  name="character_reference_1"
                  rules={[validation.charRefRules]}
                >
                  {charRef}
                </Form.List>
                <Form.List
                  name="character_reference_2"
                  rules={[validation.charRefRules]}
                >
                  {charRef}
                </Form.List>
                <Form.List
                  name="character_reference_3"
                  rules={[validation.charRefRules]}
                >
                  {charRef}
                </Form.List>
              </CharacterRefContainer>
            )}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ApplicantContactsForm;
